import { useChargingHistories } from './queries/chargingHistoryQueries';

export const useChargingHistorySimple = (params = {}) => {
  const { data: chargingHistoryData, isLoading, error } = useChargingHistories(params);

  const chargingHistory = chargingHistoryData?.Items || [];
  const totalCount = chargingHistoryData?.Total || chargingHistoryData?.total || chargingHistory.length;

  return {
    chargingHistory,
    isLoading,
    error,
    totalCount,
  };
};

export default useChargingHistorySimple;